import { Select, MenuItem, FormControl, Box } from "@mui/material";
import { Poppins } from "next/font/google";

const poppins = Poppins({
  weight: ["100", "200", "300", "400", "500", "600", "700", "800", "900"],
  subsets: ["latin"],
  display: "swap",
});

const CSelectField = ({
  options = [],
  value,
  onChange,
  placeholder = "Select",
  customStyles = {},
  fullWidth = true,
  error,
}) => {
  return (
    <FormControl fullWidth={fullWidth} sx={customStyles}>
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        sx={{
          fontSize: "20px",
          "& .MuiOutlinedInput-input": {
            padding: "17.7px 14px",
            fontSize: "20px",
          },
          fontFamily: poppins.style.fontFamily,
          ...customStyles.select,
          "&.MuiInputBase-root svg": {
            color: "#33415C !important",
          },
        }}
        renderValue={(selected) => {
          if (selected === "") {
            return (
              <span
                style={{
                  fontFamily: poppins.style.fontFamily,
                  fontSize: "20px",
                  fontWeight: 400,
                  color: "#BBBFC9",
                  // color: "red",
                }}
              >
                {placeholder}
              </span>
            );
          }
          return selected;
        }}
        error={error}
      >
        {options.map((option, index) => (
          <MenuItem key={index} value={option.value} style={{display:"flex", alignItems:"center", justifyContent:"left"}}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CSelectField;
